import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import LojistasPage from './components/LojistasPage';
import DeepLinkRedirect from './components/DeepLinkRedirect';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/lojistas" element={<LojistasPage />} />
        <Route path="/orders-summary-detail/:orderGuid" element={<DeepLinkRedirect />} />
        <Route path="/store/:ownerName" element={<DeepLinkRedirect />} />
        {/* Legacy: /orders-summary-detail?orderGuid= — kept for backward compatibility */}
        <Route path="/orders-summary-detail" element={<DeepLinkRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
